
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/friends/invite",
      function () {
        return require("private-next-pages/friends/invite.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/friends/invite"])
      });
    }
  